import React from 'react';

import { Button } from '@eika/button';

import useTranslation from '../../../hooks/useTranslation';
import { Content } from '../Content';
import { ErrorCardWrapper } from '../ErrorCardWrapper';

import './ActionResultinfo.scss';

type RequestExceptionWithResponse = import('@eika-infrastruktur/request').RequestExceptionWithResponse;

export interface RequestResultInfoModalProps {
    title: string;
    defaultError?: string;
    error?: RequestExceptionWithResponse;
    retry?: () => void;
    icon: JSX.Element;
    successButton?: JSX.Element;
}

const ActionResultInfo: React.FC<RequestResultInfoModalProps> = ({
    title,
    defaultError,
    error,
    icon,
    successButton,
    retry,
}) => {
    const translated = useTranslation();

    if (error) {
        return (
            <Content>
                <ErrorCardWrapper exception={error} defaultError={defaultError} isModal>
                    {retry && <Button onClick={retry}>{translated.ok}</Button>}
                </ErrorCardWrapper>
            </Content>
        );
    }

    return (
        <section className="action-result-info__message">
            <Content>
                {icon}
                <h2 className="typography-h3">{title}</h2>
                {successButton}
            </Content>
        </section>
    );
};

export default ActionResultInfo;
